import { updateObject } from "../../helpers/utility.helper";
import IRealtimeViewState from "../models/IRealtimeViewState";
import { initialState } from "../state/realtimeViewSensorData.state";
import iaqRealtimeViewDataType from "../types/iaqRealtimeView.type";

const getRealtiveViewChartDataStart = (
  oldState: IRealtimeViewState,
  action: any,
) => {
  return updateObject(oldState, {
    realtimeViewChartDataState: updateObject(
      oldState.realtimeViewChartDataState,
      {
        error: null,
        loading: true,
        success: false,
      },
    ),
  });
};

const getRealtiveViewChartDataSuccess = (
  oldState: IRealtimeViewState,
  action: any,
) => {
  return updateObject(oldState, {
    realtimeViewChartDataState: updateObject(
      oldState.realtimeViewChartDataState,
      {
        data: action.payload,
        error: null,
        success: true,
        loading: false,
      },
    ),
  });
};

const getRealtiveViewChartDataError = (
  oldState: IRealtimeViewState,
  action: any,
) => {
  return updateObject(oldState, {
    realtimeViewChartDataState: updateObject(
      oldState.realtimeViewChartDataState,
      {
        error: action.payload,
        success: false,
        loading: false,
      },
    ),
  });
};

const resetRealtiveViewChartData = (
  oldState: IRealtimeViewState,
  action: any,
) => {
  return updateObject(oldState, {
    realtimeViewChartDataState: updateObject(
      oldState.realtimeViewChartDataState,
      {
        data: initialState.realtimeViewChartDataState.data,
        error: null,
        success: true,
        loading: false,
      },
    ),
  });
};

const iaqRealtimeViewChartReducer = (
  oldState: IRealtimeViewState = initialState,
  action: any,
) => {
  switch (action.type) {
    case iaqRealtimeViewDataType.GET_IAQ_REALTIME_VIEW_CHART_DATA_START:
      return getRealtiveViewChartDataStart(oldState, action);
    case iaqRealtimeViewDataType.GET_IAQ_REALTIME_VIEW_CHART_DATA_SUCCESS:
      return getRealtiveViewChartDataSuccess(oldState, action);
    case iaqRealtimeViewDataType.GET_IAQ_REALTIME_VIEW_CHART_DATA_ERROR:
      return getRealtiveViewChartDataError(oldState, action);
    case iaqRealtimeViewDataType.RESET_IAQ_REALTIME_VIEW_CHART_DATA:
      return resetRealtiveViewChartData(oldState, action);
    default:
      return oldState;
  }
};
export default iaqRealtimeViewChartReducer;
